/**
 * React Query hooks for the fitness trend (PMC) and the power curve.
 */
import { useQuery } from '@tanstack/react-query';
import { axiosClient } from '../lib/api.ts';
import type { FitnessResponse, PowerCurveResponse } from '../types/api.ts';

const STALE_MS = 60_000;

export function useFitness(days: number) {
  return useQuery<FitnessResponse>({
    queryKey: ['fitness', days],
    queryFn: () => axiosClient.get('/fitness', { params: { days } }).then((r) => r.data),
    staleTime: STALE_MS,
  });
}

export function usePowerCurve(days: number, compare: boolean, enabled = true) {
  return useQuery<PowerCurveResponse>({
    queryKey: ['power-curve', days, compare],
    queryFn: () =>
      axiosClient
        .get('/power-curve', { params: compare ? { days, compare: true } : { days } })
        .then((r) => r.data),
    enabled,
    staleTime: STALE_MS,
  });
}
